import request from "../utils/request";

export const list = (data) => request.get("/api/property_type", data);
export const select = (data) => request.get("/api/property_type/select", data);
export const create = (data) => request.post("/api/property_type", data);
export const update = (id, data) => request.put(`/api/property_type/${id}`, data);
export const remove = (id) => request.del(`/api/property_type/${id}`);
export const toggle = (id) => request.put(`/api/property_type/${id}/toggle`);
export const get = (id) => request.get(`/api/property_type/${id}`);